module.exports = __webpack_public_path__ + "static/promo-text-889add25f08a456d6a5189cb5bbdfbb4.svg";